<!-- Cancel comes first so the harmless answer takes focus. The content hangs off
     `options` instead of an `@if`, so it survives the close animation. -->
@let current = options();
<!-- The dialog never closes itself; escape, backdrop and the close icon come back
     as `dmModalCloseClick` and are answered here. -->
<dm-modal
  [size]="current?.compact ? 'xs' : 'sm'"
  [open]="isOpen()"
  [label]="current?.title ?? ''"
  [canautoclose]="false"
  [withclickoutside]="false"
  [returnFocusTo]="current?.returnFocusTo"
  (dmModalCloseClick)="answer('dismissed')"
  (dmOpenChange)="onOpenChange($event.detail)"
  (dmModalClosed)="onClosed()"
>
  <dm-modal-header
    slot="header"
    [align]="current?.align ?? 'center'"
    [stacked]="true"
    [bordered]="false"
    pattern="circle"
    [heading]="current?.title ?? ''"
    [description]="current?.description ?? ''"
  >
    <dm-icon
      slot="icon"
      [featured]="true"
      theme="light"
      [color]="current?.tone === 'destructive' ? 'error' : 'brand'"
      size="lg"
      [name]="current?.icon ?? ''"
    />
  </dm-modal-header>
  @if (current?.details?.length) {
    <ul class="lp-confirm-dialog__details">
      @for (detail of current?.details; track detail) {
        <li>{{ detail }}</li>
      }
    </ul>
  }

  <dm-modal-footer slot="footer" [bordered]="false">
    @if (current?.dismissLabel) {
      <dm-button color="tertiary" dmType="button" (click)="answer('dismissed')">
        {{ current?.dismissLabel }}
      </dm-button>
    }
    <dm-button color="secondary" dmType="button" (click)="answer('declined')">
      {{ current?.cancelLabel }}
    </dm-button>
    <dm-button dmType="button" [color]="current?.tone === 'destructive' ? 'primary-destructive' : 'primary'" (click)="answer('confirmed')">
      {{ current?.confirmLabel }}
    </dm-button>
  </dm-modal-footer>
</dm-modal>
